import Campaign from "components/Campaign";
import ProductLayout from "../../layouts/ProductLayout";
import FooterCampaign from "components/Campaign/FooterCampaign";

function CampaignPage() {
  return (
    <>
      <ProductLayout namePage="แคมเปญ" footerComponent={<FooterCampaign />}  >
        <div className="layout-content">
          <Campaign />
        </div>
      </ProductLayout>
    </>
  );
}

export default CampaignPage;
